import {InputAdornment as MUIInputAdornment} from '@mui/material';


export default MUIInputAdornment;
